import * as angular from 'angular';
import * as _ from 'lodash';
import UIUtilityServiceName, { UIUtilityService } from "../../services/utility/uiUtility.service";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import Highcharts = require('highcharts');

const requires = [
	UIUtilityServiceName
];

export interface CavityEfficiencyGraphController {
	cavities: apsViewModels.CavityCountSummary[];
	setCavities(cavities: apsViewModels.CavityCountSummary[]);
	cavitySelected: (cavity: apsViewModels.CavityCountSummary) => void;
	options: any;
}

class CavityEfficiencySummaryGraphController implements CavityEfficiencyGraphController {
	uiUtilityService: UIUtilityService;
	cavities: apsViewModels.CavityCountSummary[];
	cavityNameToColor: { [cavity: string]: string };
	options = {
		chart: {
			type: 'column'
		},
		title: {
			text: ''
		},
		subtitle: {
			text: ''
		},
		accessibility: {
			announceNewData: {
				enabled: true
			}
		},
		xAxis: {
			type: 'category',
			title: {
				text: 'Machine Position'
			}
		},
		yAxis: {
			title: {
				text: 'Passed Inspection / (% Good)'
			}
		},
		legend: {
			enabled: false
		},
		credits: {
			enabled: false
		},
		plotOptions: {
			series: {
				borderWidth: 0,
				dataLabels: {
					enabled: true,
					format: '{point.y:.0f}<br />{point.z:.2f}%'
				}
			}
		},
		tooltip: {
			formatter: function () {
				return 'Cavity: <b>' + this.point.name + '</b><br />Count: <b>'
					+ Highcharts.numberFormat(this.point.y, 0)
					+ '</b><br />Cavity Efficiency: <b>' + Highcharts.numberFormat(this.point.z, 1) + '%</b>';
			}
		},
		reflow: true,
		series: [],
		click: null
	};

	cavitySelected: (cavity: apsViewModels.CavityCountSummary) => void;

	constructor(uiUtilityService: UIUtilityService) {
		this.uiUtilityService = uiUtilityService;
		this.options.click = angular.bind(this, (cavity) => {
			if (cavity) {
				const selectedCavity = _.find(this.cavities, { cavity: cavity });
				if (selectedCavity && this.cavitySelected) {
					this.cavitySelected(selectedCavity);
				}
			}
		});
	}

	setCavities(cavities: apsViewModels.CavityCountSummary[]): void {
		const series = [{
			name: "Counts",
			data: this.cavities.map((cavity) => {
				const count = cavity.inspectCount - cavity.rejectCount;
				const cavityEfficiency = (count / cavity.inspectCount) * 100.0;
				const color = this.uiUtilityService.getEfficiencyColor(cavityEfficiency);
				return {
					name: cavity.cavity,
					y: count,
					color: color,
					z: cavityEfficiency,
					select: angular.bind(this, (cavity) => {
						if (cavity) {
							const selectedCavity = _.find(this.cavities, { cavity: cavity });
							if (selectedCavity && this.cavitySelected) {
								this.cavitySelected(selectedCavity);
							}
						}
					}),
					events: {
						click: function () {
							this.select(this.name)
						}
					}
				};
			})
		}];
		this.options.series = series;
	}
}

export default angular.module('aps.controller.cavityEfficiencySummaryGraph', requires)
	.controller('CavityEfficiencySummaryGraphCtrl', CavityEfficiencySummaryGraphController)
	.name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/cavityEfficiencySummaryGraph.controller.ts